export default "__VITE_ASSET__CdZ8$PK6__"